<template>
  <div class="ch-hero" :style="heroStyle">
    <div class="ch-hero-greeting">
      <div class="ch-welcome-highlight mb-2">
        <span class="ch-welcome-text">Welcome, {{ reservation.greeting }}</span>
      </div>
      <h1 class="ch-greeting-title text-white mb-0">
        What can we<br>
        <span style="font-weight:300; opacity: 0.9">arrange for you?</span>
      </h1>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'ConciergeHero',
    props: {
      heroStyle:   { type: Object, required: true },
      reservation: { type: Object, required: true },
    },
  }
</script>

<style scoped>
.ch-hero {
  position: relative;
  height: fit-content;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  padding: 48px 24px 62px;
  overflow: hidden;
}

.ch-hero-greeting {
  position: relative;
  z-index: 2;
  margin-bottom: 12px;
}

.ch-welcome-highlight {
  background: rgba(255, 255, 255, 0.05);
  backdrop-filter: blur(8px);
  width: fit-content;
  padding: 6px 12px;
  border-radius: 99px;
  border: 1.5px solid rgba(255, 255, 255, 0.4);
  line-height: 1 !important;
}

.ch-welcome-text {
  font-size: 14px;
  font-weight: 600;
  color: #fff;
  letter-spacing: 0.3px;
}

.ch-greeting-title {
  font-size: 28px;
  font-weight: 800;
  line-height: 1;
  letter-spacing: -1.2px;
  text-shadow: 0 4px 20px rgba(0,0,0,0.4);
}
</style>



// WEBPACK FOOTER //
// src/components/v2/ConciergeHero.vue